import * as React from 'react';
import { SVGProps, Ref, forwardRef } from 'react';
const SvgPlay = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M14.548 7.14 4.01.895a1 1 0 0 0-1.51.86v12.49a1 1 0 0 0 1.51.86L14.548 8.86a1 1 0 0 0 0-1.72Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;
